import createMetadataAPITypes from './api-metadata-types';

export default ({ baseType }) => {
  if (!baseType) {
    throw new Error('Basetype is not defined');
  }
  const types = createMetadataAPITypes({ baseType });

  return {
    startFetch: () => ({
      type: types.START,
      success: true
    }),
    fetchSuccessful: (data, options = { replace: true }, loadingStatus = {}, fullFetch, except = null) => ({
      type: types.SUCCESS,
      payload: { data, loadingStatus },
      timestamp: Date.now(),
      // true if all objects should be replaced, false if merged with existing
      success: true,
      replace: options.replace,
      except,
      fullFetchComplete: fullFetch
    }),
    fetchFailed: error => ({
      type: types.ERROR,
      error,
      success: false,
      timestamp: Date.now()
    }),
    saveToBackendSuccessful: data => ({
      type: types.SAVE_TO_BACKEND_SUCCESS,
      success: true,
      payload: { data }
    }),
    createInBackendSuccessful: (data, oldId) => ({
      type: types.CREATE_IN_BACKEND_SUCCESS,
      success: true,
      payload: { oldId, data }
    }),
    deleteFromBackendSuccessful: id => ({
      type: types.DELETE_FROM_BACKEND_SUCCESS,
      success: true,
      payload: { id }
    }),
    newObjectCreated: data => ({
      type: types.OBJECT_CREATED,
      success: true,
      payload: { data }
    }),
    newObjectsCreated: data => ({
      type: types.OBJECTS_CREATED,
      success: true,
      payload: { data }
    }),
    fieldsUpdated: (id, values) => ({
      type: types.FIELDS_UPDATED,
      success: true,
      payload: { id, values }
    }),
    validationErrorsReceived: (id, validationErrors) => ({
      type: types.VALIDATION_ERRORS_RECEIVED,
      success: false,
      payload: { id, validationErrors }
    })
  };
};
